import { useContext } from 'react';
import { AuthContext } from '../screens/auth/auth.utils';

export function useIsBusinessUser() {
  const { webAuth } = useContext(AuthContext);

  return Boolean(webAuth?.business);
}
